import { useMemo } from 'react';
import type { UseQueryOptions } from '@tanstack/react-query';

import type { Slate } from '../interfaces/slates.interface';
import { findDefaultSlate } from '../services/find-default-slate.utils';

import useSlates from './useSlates';

export const useDefaultSlate = (
  scheduleId?: string,
  options?: Omit<UseQueryOptions<Slate[]>, 'queryKey' | 'queryFn'>
) => {
  const { data: contestSlates, isLoading, isError } = useSlates(scheduleId, options);

  const slate = useMemo(() => findDefaultSlate(contestSlates), [contestSlates]);

  return { slate, isLoading, isError };
};
